<template>
  <v-list-item color="transparent">
    <v-list-item-content>
      <div elevation="0" color="transparent" :style="profileImageStyle">
        <div v-for="(profile, index) in profileItems" :key="index">
          <v-hover v-slot="{ hover }">
            <v-card
              rounded="0"
              :ripple="false"
              :append="false"
              :link="false"
              class="tansparent"
              color="transparent"
              :height="index === 0 ? '14px' : '12px'"
              :width="'100%'"
              :elevation="hover ? 0 : 0"
              @mouseover="indexHover = index"
              @mouseleave="indexHover = 4"
            >
              <v-row
                class="ma-0 pa-0"
                @click="() => selectProfile(index, profile.value)"
              >
                <v-icon
                  class="ml-14"
                  size="20"
                  v-if="shouldShowIcon(index, hover)"
                >
                  mdi-chevron-right
                </v-icon>
              </v-row>
            </v-card>
          </v-hover>
        </div>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
const PROFILE_ITEMS = [
  { value: "A", srcImage: "/50rojo-selec.png", color: "red" },
  { value: "B", srcImage: "/50naranja-selec.png", color: "orange" },
  { value: "C", srcImage: "/50amarillo-selec.png", color: "yellow" },
  { value: "D", srcImage: "/50azul-selec.png", color: "blue" },
  { value: "", srcImage: "/vacio-selec.png", color: "blue" }
];

export default {
  name: "ThermometerProbability",
  props: {
    value: String
  },
  data() {
    return {
      profileItems: PROFILE_ITEMS,
      indexSelected: 4,
      indexHover: 4,
      showProfileSelect: false,
      showfilterProfiles: false
    };
  },
  computed: {
    filterProfiles: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    profileImageStyle() {
      const selectedIndex = this.filterProfiles
        ? this.indexSelected
        : this.indexHover;
      return {
        height: "70px",
        backgroundImage: `url(${this.profileItems[selectedIndex].srcImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center"
      };
    }
  },
  methods: {
    selectProfile(index, value) {
      this.filterProfiles = value;
      this.showProfileSelect = false;
      this.showfilterProfiles = false;
      this.indexSelected = index;
    },
    shouldShowIcon(index, hover) {
      return (
        (hover && this.indexHover !== this.indexSelected) ||
        (this.filterProfiles && this.indexSelected === index && index !== 4) ||
        (!this.filterProfiles && index === 4)
      );
    }
  }
};
</script>
